import React, { useState, useEffect, useRef } from 'react'; // Import useState, useEffect, useRef
import { Link } from 'react-router-dom';
import logo from '../data/logo/bog_hub_logo.png';
import './Header.css';
import { useAuth } from '../AuthContext';

function Header() {
  const { loggedIn, userID, userName, userAvatar, logout } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State for dropdown visibility
  const dropdownRef = useRef(null); // Ref to detect clicks outside

  const getAvatarUrl = () => {
    if (loggedIn && userID && userAvatar) {
      return `https://cdn.discordapp.com/avatars/${userID}/${userAvatar}.png`;
    }
    return null; // Or a default avatar path
  };

  const avatarUrl = getAvatarUrl();

  const toggleDropdown = () => {
    setIsDropdownOpen(prev => !prev); 
  };

  // Effect to handle clicks outside the dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      // If the dropdown is open and the click is outside the dropdown area
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false); 
      }
    }

    // Add event listener only when the dropdown is open
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      // Clean up the event listener when the dropdown is closed or component unmounts
      document.removeEventListener('mousedown', handleClickOutside);
    }

    // Cleanup function for when the component unmounts or isDropdownOpen changes
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]); 

  return (
    <header className="site-header">
      <div className="header-content">
        <div className="logo">
          <Link to="/"><img src={logo} alt="Bog Hub"/></Link>
        </div>
        <nav className="main-nav">
          <ul>
            {/* Static links */}
            <li><Link to="/membership"><b>Memberships</b></Link></li>
            <li><Link to="/about"><b>About BogAI</b></Link></li>
            <li><Link to="https://discord.com/oauth2/authorize?client_id=1382543634930339870&permissions=2151148608&integration_type=0&scope=bot"><b>Invite to your server</b></Link></li>

            {/* --- Conditional Rendering for User --- */}
            {loggedIn ? (
              // --- RENDER THIS IF USER IS LOGGED IN ---
              <li className="user-menu-item" ref={dropdownRef}> {/* Use ref here */}
                {/* Avatar acts as the dropdown trigger */}
                <button onClick={toggleDropdown} className="avatar-button" aria-haspopup="true" aria-expanded={isDropdownOpen}>
                  {avatarUrl ? (
                     <img className="user-avatar" src={avatarUrl} alt={`${userName}'s avatar`} />
                  ) : (
                     <span className="default-avatar-placeholder">?</span> // Placeholder if no avatar
                  )}
                </button>

                {/* --- Dropdown Menu --- */}
                {isDropdownOpen && (
                  <div className="dropdown-menu">
                    <ul> 
                       <li><Link to="/dashboard" onClick={() => setIsDropdownOpen(false)}>User Dashboard</Link></li>
                       <li><Link to="/server_dash" onClick={() => setIsDropdownOpen(false)}>Server Dashboard</Link></li>
                       <li><Link to="/" onClick={() => { logout(); setIsDropdownOpen(false); }}>Logout</Link></li>
                    </ul>
                  </div>
                )}
              </li>
            ) : (
              // --- RENDER THIS IF USER IS LOGGED OUT ---
              <li>
                <Link to="https://discord.com/oauth2/authorize?client_id=1382543634930339870&response_type=code&redirect_uri=https%3A%2F%2Fbog-hub.com%2F&scope=guilds+identify">
                  <b>Login</b>
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;